import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  IconTypes,
  PencilIconComponent,
} from 'src/app/standalones/components/pencil-icon/pencil-icon.component';
import { User } from 'src/app/models/user';
import { CommonModule } from '@angular/common';
import { UiModule } from 'src/app/ui/ui.module';
import { SpaceUsersTooltipContentComponent } from '../spaces-list/space-users-tooltip-content/space-users-tooltip-content.component';

@Component({
  selector: 'app-presence-indicator-users',
  templateUrl: './presence-indicator-users.component.html',
  styleUrls: ['./presence-indicator-users.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, PencilIconComponent, UiModule, SpaceUsersTooltipContentComponent],
})
export class PresenceIndicatorUsersComponent {
  @Input() users: User[] = [];
  @Input() maxLength: number = 3;
  @Input() iconName: string = '';

  readonly IconTypes = IconTypes;

  /** Number of user tiles that should show for in call users */
  numberOfUsersToShow(users: User[]) {
    return users?.length > this.maxLength ? this.maxLength - 1 : users.length;
  }
}
